// ============================================
// Splide
// ============================================

// import Splide JS
import Splide from "@splidejs/splide";

export default function initSplide() {
  // ============================================
  // トップ メインスライダー
  // ============================================

  function _initHmSlider() {
    const hmSlider = document.querySelector(".js-hm-slider");
    if (!hmSlider) return;

    const slider = new Splide(".js-hm-slider", {
      type: "fade",
      rewind: "true",
      autoplay: true,
      interval: 5000,
      speed: 2000,
      arrows: false,
      pagination: true,
      classes: {
        pagination: "splide__pagination pg-hm-mv-slider__pagination",
        page: "splide__pagination pg-hm-mv-slider__page",
      },
    });

    slider.mount();
  }

  _initHmSlider();
}
